<template>
  <of-dialog
    :title="formTitle"
    @onCancel="cancel"
    @onConfirm="confirm"
    :isConfirm="isConfirm"
    :width="width"
  >
    <div slot="content">
      <el-form
        ref="form"
        label-width="120px"
        :model="dataForm"
        :rules="editFormRules"
      >
        <el-form-item label="收入金额：" prop="Amount">
          <el-input
            placeholder="请输入收入金额"
            v-model="dataForm.Amount"
            clearable
            type="number"
            style="width: 200px"
          ></el-input>
        </el-form-item>
        <el-form-item label="资金来源：" prop="Source">
          <el-select v-model="dataForm.Source" placeholder="请选择">
            <el-option
              v-for="item in SourceOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="款项说明：" prop="Explain">
          <el-input
            placeholder="请输入款项说明"
            v-model="dataForm.Explain"
            type="textarea"
            :rows="4"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="到账时间：" prop="FinishTime">
          <el-date-picker
            v-model="dataForm.FinishTime"
            type="datetime"
            value-format="timestamp"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="上传附件：" prop="File">
          <el-upload
            class="upload-demo"
            drag
            action="/api/File/FileUpload"
            multiple
            :on-success="onFileUpdate"
            :on-remove="OnFileRemove"
            :on-preview="onFilePreview"
            :file-list="fileList"
            accept=".xls, .doc, .ppt, .xlsx, .docx, .pptx, .txt, .pdf, .zip, .rar"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              支持扩展名：.rar .zip .doc .docx .pdf .jpg...
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
    </div>
  </of-dialog>
</template>
<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import OfUpload from "@/components/controls/of_upload/of_upload";
import api from "@/modules/zjrc/api";
import { saveAs } from "file-saver";

export default {
  name: "edit",
  props: {
    dataForm: {
      type: Object,
      default: null,
    },
    formTitle: {
      type: String,
      default: "",
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      //表单规则
      editFormRules: {
        Amount: {
          required: true,
          message: "输入金额不能为空",
          trigger: "blur",
        },

        Source: {
          required: true,
          message: "资金来源不能为空",
          trigger: "blur",
        },

        Explain: {
          required: true,
          message: "款项说明不能为空",
          trigger: "blur",
        },

        FinishTime: {
          required: true,
          message: "到账时间不能为空",
          trigger: "blur",
        },
      },
      SourceOption: [
        {
          value: 0,
          label: "社会捐赠",
        },
        {
          value: 1,
          label: "财政拨款",
        },
        {
          value: 2,
          label: "其他",
        },
      ], //资金来源
      isConfirm: false,
      width: "60%",
      fileList: [], //附件数组
    };
  },
  mounted() {
    this.getfile();
  },
  components: {
    OfDialog,
    OfUpload,
  },
  methods: {
    //取消
    cancel() {
      this.$emit("formCallBack", null);
    },
    //保存&更新
    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.isConfirm = true;
          let params = Object.assign({}, this.dataForm);
          params.FinishTime = params.FinishTime / 1000;
          api
            .SaveCapitalIndexCapitalIncome(params)
            .then((rep) => {
              this.isConfirm = false;
              if (rep.data.Code === 0) {
                this.$message({
                  message: "提交成功",
                  type: "success",
                });
                this.$emit("formCallBack", params);
              } else {
                this.isConfirm = false;
                this.$message({
                  message: rep.data.Message,
                  type: "error",
                });
              }
            })
            .catch((e) => {
              this.isConfirm = false;
              this.$message({
                message: e.toString(),
                type: "error",
              });
            });
        }
      });
    },
    //初始化附件
    getfile() {
      let that = this;
      if (that.dataForm.File || that.dataForm.File != null) {
        let params = { Id: that.dataForm.File };
        api.QueryBigSickApplyFileByIds(params).then((res) => {
          if (res.data.Code == 0) {
            let fileList = res.data.Data;
            fileList.forEach((item) => {
              let response = { Data: { FileId: item.Id } };
              that.fileList.push({
                url: item.Url,
                name: item.FileName,
                response: response,
              });
            });
          }
        });
      }
    },
    //附件上传
    onFileUpdate(rtnResult) {
      let that = this;
      if (rtnResult.Code == 0) {
        if (!that.dataForm.File && !that.dataForm.File) {
          that.dataForm.File = rtnResult.Data.FileId;
        } else {
          that.dataForm.File += "," + rtnResult.Data.FileId;
        }
        that.$message({
          message: "附件上传成功",
          type: "success",
        });
      }
    },
    //附件删除
    OnFileRemove(file, fileList) {
      let that = this;
      that.dataForm.File = "";
      fileList.forEach((item) => {
        if (that.dataForm.File == "") {
          that.dataForm.File = item.response.Data.FileId;
        } else {
          that.dataForm.File += "," + item.response.Data.FileId;
        }
      });
    },
    //附件下载
    onFilePreview(file) {
      saveAs("/api/File/Download?Id=" + file.response.Data.FileId, file.name);
    },
  },
};
</script>


<style scoped>
.upload-demo >>> .el-upload input[type="file"] {
  display: none !important;
}

.el-date-editor >>> .el-input__icon {
  display: none;
}

.el-date-editor >>> .el-input__inner {
  width: 90%;
}
.upload-demo >>> .el-upload-dragger {
  width: 270px;
  height: 120px;
}
.upload-demo >>> .el-icon-upload {
  margin: 10px 0 16px;
}
</style>
